<template>
	<div :class="['app-input', { 'has-error': hasError }, $slots['icon-left'] ? 'has-icon-left' : '', $slots['icon-right'] ? 'has-icon-right' : '']" role="group">
		<label v-if="$slots.label" :for="inputId" class="app-input__label">
			<slot name="label" />
		</label>

		<div class="app-input__wrapper">
			<!-- Icono izquierdo -->
			<span v-if="$slots['icon-left']" class="app-input__icon app-input__icon--left" aria-hidden="true">
				<slot name="icon-left" />
			</span>

			<input ref="inputRef" :id="inputId" :type="type" class="app-input__field" :placeholder="placeholder" :disabled="isDisabled" :value="modelValue" :aria-invalid="hasError || undefined" :aria-disabled="isDisabled || undefined" v-bind="mergedAttrs" @input="handleInput" @focus="handleFocus" />

			<!-- Icono derecho -->
			<span v-if="$slots['icon-right']" class="app-input__icon app-input__icon--right" aria-hidden="true">
				<slot name="icon-right" />
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppInput",
	inheritAttrs: false,

	props: {
		id: { type: String, default: null },
		modelValue: { type: String, default: "" },
		placeholder: { type: String, default: "" },
		type: { type: String, default: "text" },
		isDisabled: { type: Boolean, default: false },
		hasError: { type: Boolean, default: false },
		size: {
			type: String,
			default: "",
			validator: (value) => ["", "small", "base", "large"].includes(value),
		},
		border: {
			type: String,
			default: "",
			validator: (value) => ["", "square", "rounded", "none"].includes(value),
		},
		accent: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			inputRef: null,
			generatedId: `input-${Math.random().toString(36).substr(2, 9)}`,
		};
	},

	computed: {
		inputId() {
			return this.id || this.generatedId;
		},

		mergedAttrs() {
			const merged = { ...this.$attrs };

			if (this.size && this.size !== "base") {
				merged[this.size] = true;
			}

			if (this.border) {
				merged[this.border] = true;
			}

			if (this.accent) {
				merged.accent = true;
			}

			return merged;
		},
	},

	methods: {
		handleInput(event) {
			this.$emit("update:modelValue", event.target.value);
		},
		handleFocus(event) {
			this.$emit("focus", event);
		},
		focus() {
			this.$refs.inputRef?.focus();
		},
	},
};
</script>
